import { render, staticRenderFns } from "./SavedCarts.vue?vue&type=template&id=cf62d4b2"
import script from "./SavedCarts.vue?vue&type=script&lang=ts"
export * from "./SavedCarts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports